/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useImperativeHandle, useEffect, Fragment } from 'react';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { Box, Button, Typography } from "@mui/material";
import dayjs from 'dayjs';
import { InvoiceView, InvoiceLinesList } from "./Blocks";
import { Space, Modal, Image } from "antd";
import { checkComponentPermission, idNamingConversion, downloadTitle, currencyFormat, gstCalculation, getColumnWidth, capitalizeFirstLetter } from '../../../../../helpers/utilities';
import { useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import moment from 'moment';
import gstActions from "../../../../Admin/Setup/redux/actions";
import { NavLink } from "react-router-dom";
import { templateType } from '../../../../../config/constant';
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import InvoiceModal from "../../../../Shared/components/InvoiceModal";
import { useEventListener } from "../../../../../helpers/useEventListener";
import qucikLinksActions from "../../../../Dashboard/redux/actions";


export const InvoiceForm = React.forwardRef((props, ref) => {
    const { parameterDetails } = useSelector(state => state.homeReducer);
    const { partyGstdetails, productGstdetails, hsnDetails, taxCodedetails, otherTaxesdetails, cashDiscountDetails } = useSelector(state => state.adminSetupReducer);
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const { view, showDetails, type, clsx, dispatch, classes, roleManagement, orderId } = props;
    const childRef = useRef('');
    const formRef = useRef('');
    const [lines, setLines] = useState([]);
    const [selected, setSelected] = useState([]);
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const prevEditError = usePrevious(editError);
    const prevEditDetails = usePrevious(editDetails);
    const [previewData, setPreviewData] = useState({});
    const [preview, setPreview] = useState(false);
    const [open, setOpen] = useState(false);
    const [changeSelected, setChangeSelected] = useState(false);
    const [value, setValue] = useState('lineView');


    const handleSubmit = (e) => {
        e.preventDefault();
        handleCommonSubmit(form?.OrderStatus);
    }

    useEffect(() => {
        loadTasks();
    }, []);

    const loadTasks = () => {
        dispatch({
            type: gstActions.PARTYGST_DETAILS_START, url: 'partygst', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id desc'
            }
        });
    }

    const handleCommonSubmit = (status, callDispatch = true) => {
        childRef?.current?.handleAdjustHeight();
        let dueDateCheck = moment(moment(form.dueDate).format('YYYY-MM-DD')).isSameOrAfter(moment(form.invoiceDate).format('YYYY-MM-DD'));
        setError({});
        if (dueDateCheck) {
            let a = [];

            lines && lines?.length > 0 && lines?.filter((el) => { return selected.find((e) => e === el.id) })?.map((element, i) => {
                return a.push({ ...element })
            });
            form.salesOrderLineItems = a;
            let subForm = { ...form };

            if (callDispatch) {
                delete subForm.includeDisabled; delete subForm.currency; delete subForm.area; delete subForm.city;
                delete subForm.state; delete subForm.country; delete subForm.netAmount; delete subForm.totalDiscount;
                delete subForm.business; delete subForm.partyGst; delete subForm.mop; delete subForm.pincode; delete subForm.invoice_billFormatDisabled;
                delete subForm.customer; delete subForm.inAppStatus; delete subForm.createdBy; delete subForm.businessDocumentTemplates;
                delete subForm.updatedBy; delete subForm.createTs; delete subForm.updateTs; delete subForm.id; delete subForm.origin;
                delete subForm.manualInvoiceNo; delete subForm.cashDiscount; delete subForm.taxCode; delete subForm.tcsName;
                delete subForm.totalInvoiceAmount; delete subForm.isViaNotification; delete subForm.version; delete subForm.supplyOrderId; delete subForm.gstin;
                if (lines.length === form.salesOrderLineItems.filter(el => el.available_quantity === 0).length) {
                    subForm.OrderStatus = 'INVOICED';
                }
                a?.length > 0 && a?.map((element, i) => {
                    element.lineStatus = 'INVOICED';
                    delete element.cgstAmount;
                    delete element.discountCalcAmount;
                    delete element.discountPercAmount;
                    delete element.igstAmount;
                    delete element.number;
                    delete element.productUnitId;
                    delete element.sgstAmount;
                    delete element.useMrp;
                    delete element.hsn;
                    delete element.unit;
                    delete element.product;
                    delete element.productGst;
                    delete element.productUnit;
                    delete element.universalProduct;
                    //element.lineNumber = (i + 1);
                    return a.splice(i, 1, { ...element });
                });
                subForm.salesOrderLineItems = a;
                subForm.roundOffMethod = subForm?.roundOffMethod || null;
                dispatch({
                    type: crudActions.EDIT_DETAILS_START,
                    url: 'v1/sales-order/sales-orders',
                    title: 'Sales Order',
                    id: form?.id,
                    details: subForm
                })
            } else {
                return subForm;
            }
        } else {
            setError({
                dueDate: !dueDateCheck ? 'Due Date should greater or equal to Invoice date' : '',
            });
        }
    }

    useImperativeHandle(ref, () => ({
        onEdit(data) {
            let a = customObject(templateType, data?.businessDocumentTemplates[0]?.self_bill_template);
            let dF = {
                ...data,
                validDate: data?.validDate ? dayjs(data?.validDate).$d : null,
                deliveryDate: data?.deliveryDate ? dayjs(data?.deliveryDate).$d : null,
                transactionDate: data?.transactionDate ? dayjs(data?.transactionDate).$d : null,
                invoiceDate: new Date(),
                dueDate: new Date(),
                invoice_billFormat: a?.id || 'format1',
                invoice_billFormatDisabled: data?.invoice_billFormat ? true : false,
                comments: data?.comments || '',
                reference: data?.reference || '',
                // roundOffMethod: '',
                // roundOffAmount: 0
            };

            let newTodos = [];
            if (data?.salesOrderLineItems) {
                newTodos = data?.salesOrderLineItems?.length > 0 ? data?.salesOrderLineItems?.filter((el) => el.available_quantity > 0).map((el) => {
                    let d = {
                        ...el,
                        'invoice_quantity': el.available_quantity,
                        'available_quantity': 0,
                        'invoice_unitPrice': el?.pricePerUnit || 0,
                        //  'invoice_netAmount': el?.amount || 0,
                        'duplicate_available_quantity': parseFloat(el.available_quantity)
                    };
                    return {
                        ...d,
                        ...calculateLineTotal(d, dF)
                    };

                }) : [];
                setLines(newTodos);
                data?.salesOrderLineItems?.length > 0 && data?.salesOrderLineItems?.filter((el) => el.available_quantity > 0)?.map((el) => {
                    return selected.push(el.id);
                });
            }

            setForm({
                ...dF, ...calculateGrandTotal(dF, newTodos?.filter((el) => el.duplicate_available_quantity > 0))
            });

            setTimeout(function () {
                dispatch({
                    type: qucikLinksActions.QUICKLINKS_START, menus: [], toggle: false,
                    factBox: '', component: "Sales Order"
                });
                childRef?.current?.handleAdjustHeight();
            }, 500)
        }
    }));

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) { // Alt + S
            e.preventDefault();
            if (form?.OrderStatus === 'ACCEPTED' && form?.invoiceAmount > 0) {
                handleSubmit(e);
            }
        } else if (e.altKey && e.keyCode === 68) { // Alt + D
            e.preventDefault();
            handlePreview();
        }
    }

    useEventListener("keydown", handleKeyDown);

    const changeHandlerLine = (data, e, name = '') => {
        const newTodos = lines.map((el) => {
            if (el.id === data.id) {
                if (name === 'invoice_quantity') {
                    return { ...el, [name]: e, 'available_quantity': parseFloat(parseFloat(data.duplicate_available_quantity) - parseFloat(e)) };
                } else {
                    return { ...el, [name]: e };
                }
            }
            return el;
        });
        setLines(newTodos);
        setChangeSelected(!changeSelected);
    }

    const changeHandler = (e, name) => {
        if (name === 'roundOffMethod') {
            let value = 0;
            if (form?.totalInvoiceAmount && e !== '') {
                if (e === 'UP') {
                    value = Math.ceil(form?.totalInvoiceAmount || 0);
                } else {
                    value = Math.floor(form?.totalInvoiceAmount || 0);
                }
            }
            setForm({
                ...form,
                [name]: e,
                'roundOffAmount': value ? parseFloat(parseFloat(value - form?.totalInvoiceAmount).toFixed(2)) : 0,
                'invoiceAmount': value ? parseFloat(parseFloat(value).toFixed(2)) : form?.totalInvoiceAmount
            });
        } else if (name === 'roundOffAmount') {
            setForm({
                ...form,
                [name]: e,
                'invoiceAmount': parseFloat(parseFloat(form?.totalInvoiceAmount + parseFloat(e || 0)).toFixed(2))
            });
        } else {
            setForm({
                ...form,
                [name]: e
            });
        }
    }

    const handleClick = (data) => {
        const selectedIndex = selected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setForm({
            ...form,
            ...calculateGrandTotal(form, lines?.filter((el) => { return newSelected.find((e) => e === el.id) }))
        });
        setSelected(newSelected);
    }

    useEffect(() => {
        if (lines && lines?.length > 0) {
            const newTodos = lines.map((el) => {
                return calculateLineTotal(el, form);
            });
            setForm({
                ...form,
                ...calculateGrandTotal(form, newTodos?.filter((el) => { return selected.find((e) => e === el.id) }))
            });
            setLines(newTodos);
        }
    }, [changeSelected]);

    const calculateLineTotal = (el, form) => {
        let data = {
            cgst: '', sgst: '', igst: '', cgstPercentage: '', sgstPercentage: '', igstPercentage: ''
        };
        const amount = el.invoice_quantity * el.invoice_unitPrice;
        let dPAmount = 0;
        let dTotal = 0;
        let gAmount = 0;

        if (el.discountPercent !== '') {
            dPAmount = dTotal = parseFloat((amount * el.discountPercent) / 100);
        }
        if (el.discountAmount && el.discountAmount !== '') {
            if (amount < 0) {
                dTotal = parseFloat(dPAmount) - parseFloat(el.discountAmount);
            } else {
                dTotal = parseFloat(dPAmount) + parseFloat(el.discountAmount);
            }
        }
        let tAmount = (amount - dTotal);
        data['invoice_netAmount'] = tAmount;

        if (el?.productGst && el.includeGst) {
            let percentage = el?.productGst?.percentage || 0;
            let details = {
                percentage: percentage,
                stateId: form?.stateId,
                lineAmount: tAmount || 0,
                priceIncludesTax: form?.priceIncludesTax || false,
            };
            let gstCalc = gstCalculation(form?.business, details, form?.customer);
            data['cgstPercentage'] = parseFloat(gstCalc.cgst);
            data['sgstPercentage'] = parseFloat(gstCalc.sgst);
            data['igstPercentage'] = parseFloat(gstCalc.igst);
            data['cgst'] = parseFloat(gstCalc.cgstAmount);
            data['sgst'] = parseFloat(gstCalc.sgstAmount);
            data['igst'] = parseFloat(gstCalc.igstAmount);
            gAmount = gstCalc.gAmount;
        }

        let result = {
            ...el,
            ...data,
            gstAmount: parseFloat(gAmount),
            discountPercAmount: dPAmount,
            discountCalcAmount: dTotal
        };
        return result;
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            setDataPreview(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            toast.error(text);
        }
    }, [editDetails, editError]);

    const lineSubmit = (data, lineId = '') => {
        if (lineId !== '') {
            let index = lines.findIndex((d, i) => lineId === i);
            if (index >= 0) {
                lines.splice(index, 1, data);
            }
        } else {
            setLines((prevState) => {
                return [...prevState, data];
            });
        }
        setChangeSelected(!changeSelected);
    }

    const hsnApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: filter,
                order: 'hsnCode asc',
                limit: 500,
                skip: 0
            },
        });
    }

    const handleIncludeGst = (value) => {
        if (!value) {
            setModalVisible(true);
        } else {
            setForm({
                ...form, includeGst: value
            });
            lines && lines.length > 0 && lines.map((element, i) => {
                let party = partyGstdetails && partyGstdetails.filter(function (el) { return el.id === form?.partyGstId });
                if (party.length >= 0) {
                    if (element.productGstId) {
                        let p = party[0].productGsts && party[0].productGsts.filter(function (el) { return el.id === element.productGstId });
                        if (p.length >= 0) {
                            let percentage = p[0].percentage;
                            let details = {
                                percentage: percentage,
                                stateId: form?.stateId,
                                lineAmount: element.amount, priceIncludesTax: form?.priceIncludesTax || false,
                            };
                            let gstCalc = gstCalculation(form?.business, details, form?.customer);
                            let mLines = {
                                ...element,
                                includeGst: true,
                                igstPercentage: parseFloat(gstCalc?.igst || 0),
                                cgstPercentage: parseFloat(gstCalc?.cgst || 0),
                                sgstPercentage: parseFloat(gstCalc?.sgst || 0),
                                cgst: parseFloat(gstCalc?.cgstAmount || 0),
                                sgst: parseFloat(gstCalc?.sgstAmount || 0),
                                igst: parseFloat(gstCalc?.igstAmount || 0),
                                gstAmount: parseFloat(gstCalc.gAmount || 0),
                            };

                            return lines.splice(i, 1, mLines);
                        }
                    }
                }
            });
        }
    }

    const handleWarningYes = () => {
        setModalVisible(false);
        setForm({
            ...form, includeGst: false
        });
        lines && lines.length > 0 && lines.map((element, i) => {
            let mLines = {
                ...element,
                includeGst: false,
                igstPercentage: 0,
                cgstPercentage: 0,
                sgstPercentage: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                gstAmount: 0,
            };
            return lines.splice(i, 1, mLines);
        });
    }

    const handlePreview = () => {
        setDataPreview();
    }

    const calculateGrandTotal = (form, lines) => {
        let data = {};
        if (lines && lines.length > 0) {
            let total = lines && lines.reduce((a, v) => a = a + v.invoice_netAmount, 0);
            let discount = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v.discountAmount), 0);
            let discountPercent = lines && lines.reduce((a, v) => {
                if (v.amount < 0) {
                    a = parseFloat(a) - parseFloat(((v.invoice_quantity * v.pricePerUnit) * v.discountPercent) / 100)
                } else {
                    a = parseFloat(a) + parseFloat(((v.invoice_quantity * v.pricePerUnit) * v.discountPercent) / 100)
                }
                return a;
            }, 0);
            let gst = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0);

            let excisesAmount = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.excisesTotal || 0), 0);
            let disAmount = 0;
            if (form?.cashDiscountId) {
                disAmount = (total * (form?.cashDiscount?.percentage || 0)) / 100;
            }

            let assessableAmount = parseFloat(total || 0) - parseFloat(disAmount || 0) + parseFloat(excisesAmount || 0);
            if (form?.priceIncludesTax) {
                assessableAmount = parseFloat(assessableAmount || 0) - parseFloat(gst || 0);
            }

            let taxValue = 0;
            if (form?.taxCodeId) {
                taxValue = ((assessableAmount || 0) * (form?.taxCode?.percentage || 0)) / 100;
            }

            let tcsValue = 0;
            let tcsAmount = parseFloat(assessableAmount || 0) + parseFloat(taxValue || 0);
            if (form?.customer?.tcsBoolean) {
                if (form?.tcsNameId) {
                    tcsValue = (tcsAmount * (form?.tcsName?.percentage || 0)) / 100;
                }
            }

            total = parseFloat(assessableAmount || 0) + parseFloat(taxValue || 0) + parseFloat(tcsValue || 0);

            data['invoiceAmount'] = total + gst + form?.roundOffAmount;
            data['totalInvoiceAmount'] = total + gst;
            data['netAmount'] = assessableAmount;
            data['assessableValue'] = assessableAmount;
            data['excisesAmount'] = excisesAmount;
            data['cashDiscountAmount'] = disAmount;
            data['tax'] = taxValue;
            data['tcs'] = tcsValue;
            data['totalDiscount'] = discount + discountPercent;
            data['gstAmount'] = gst;
            // if (form?.priceIncludesTax) {
            //     data['invoiceAmount'] = total + form?.roundOffAmount;
            //     data['totalInvoiceAmount'] = total;
            //     data['netAmount'] = total - gst;
            // } else {
            //     data['invoiceAmount'] = total + gst + form?.roundOffAmount;
            //     data['totalInvoiceAmount'] = total + gst;
            //     data['netAmount'] = total;
            // }
        } else {
            data['invoiceAmount'] = 0;
            data['totalInvoiceAmount'] = 0;
            data['totalDiscount'] = parseFloat(0.00);
            data['gstAmount'] = parseFloat(0.00);
            data['assessableValue'] = parseFloat(0.00);
            data['netAmount'] = parseFloat(0.00);
            data['excisesAmount'] = parseFloat(0.00);
            data['cashDiscountAmount'] = parseFloat(0.00);
            data['tax'] = parseFloat(0.00);
            data['tcs'] = parseFloat(0.00);
        }
        return {
            ...form, ...data
        }
    }

    const setDataPreview = (a = true) => {
        let data = handleCommonSubmit('CREATED', false);
        if (data) {
            const newTodos = data?.salesOrderLineItems?.length > 0 ? data?.salesOrderLineItems.map((el, i) => {
                return {
                    ...el,
                    //'lineNumber': (i + 1),
                    'quantity': el.invoice_quantity,
                    'pricePerUnit': el.invoice_unitPrice,
                    'amount': el.invoice_netAmount
                };
            }) : [];
            data.selfBillItems = newTodos;
            data.billFormat = data.invoice_billFormat;
            data.serialNo = '';
            setPreviewData(data);
            setPreview(a);
            setOpen(true);
        }
    }

    useEffect(() => {
        if (preview) {
            setDataPreview();
        }
    }, [preview]);

    const handleModalClose = (o) => {
        setOpen(o); setPreview(false);
    };

    const handleChange = (newValue) => {
        setValue(newValue);
        childRef?.current?.handleAdjustHeight();
    };

    return (
        <Fragment>
            <CustomAccordion
                title={`Create Invoice`}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline, classes.positionRelative)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => handleSubmit(e)}>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <>
                                <div className={clsx(classes.tabWrapSubmit)}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        <div className={classes.templateView} >
                                            <NavLink to="#" onClick={() => handlePreview()} tabIndex={-1}>
                                                <Image tabIndex={-1} className={""} src={ViewIcon} preview={false} />
                                                <span className={classes.customerInvoiceNone}>Invoice Template</span>
                                            </NavLink>
                                            <AutoCompleteComponent
                                                name={""}
                                                id={idNamingConversion('invoice_billFormat', 'salesBill', 'DropDown')}
                                                heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                details={templateType}
                                                parentValue={customObject(templateType, form?.invoice_billFormat)}
                                                onChange={(data) => { changeHandler(data.id, 'invoice_billFormat'); handlePreview(); }}
                                                position={'bottom'}
                                                disabled={form?.invoice_billFormatDisabled}
                                                customClasses={clsx(classes.customAutocomplete, classes.customerInvoice)}
                                            />
                                        </div>
                                        {
                                            roleManagement !== '' && checkComponentPermission('Sales Order', 'Page', 'Confirm') && form?.invoiceAmount > 0 &&
                                            <Button
                                                tabIndex={-1}
                                                key="Save"
                                                type="submit"
                                                color="primary"
                                                variant="contained"
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>Confirm</Button>
                                        }
                                    </Space>
                                </div>
                                <InvoiceView {...props}
                                    handleIncludeGst={(v) => handleIncludeGst(v)}
                                    error={error}
                                    customObject={(details, id) => customObject(details, id)}
                                    currencyFormat={(amount) => currencyFormat(amount)}
                                    capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                                    changeHandler={(e, name) => changeHandler(e, name)}
                                    value={value}
                                    handleChange={(v) => handleChange(v)}
                                    idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                    form={form}
                                    parameterDetails={parameterDetails}
                                    cashDiscountDetails={cashDiscountDetails}
                                    taxCodedetails={taxCodedetails}
                                    otherTaxesdetails={otherTaxesdetails}
                                />
                            </>
                        }
                    </Box>
                }
            />
            <CustomAccordion
                title={'Sales Order Lines'}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={
                    <>
                        {
                            showDetails ? <div className={classes.textAlignCenter
                            } >
                                <div className={classes.loadMoreCircle}></div>
                            </div > : <>
                                <InvoiceLinesList
                                    classes={classes}
                                    form={form}
                                    ref={formRef}
                                    type={type}
                                    idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                    currencyFormat={(amount) => currencyFormat(amount)}
                                    clsx={clsx}
                                    lines={lines}
                                    dispatch={dispatch}
                                    customObject={(details, id) => customObject(details, id)}
                                    getColumnWidth={(head, v) => getColumnWidth(head, v)}
                                    headerView={view}
                                    roleManagement={roleManagement}
                                    selected={selected}
                                    partyGstdetails={partyGstdetails}
                                    productGstdetails={productGstdetails}
                                    hsnDetails={hsnDetails}
                                    hsnApi={(s = '', id = '') => hsnApi(s, id)}
                                    handleClick={(data) => handleClick(data)}
                                    lineSubmit={(data, id) => lineSubmit(data, id)}
                                    changeHandlerLine={(data, e, name = '') => changeHandlerLine(data, e, name)}
                                    checkComponentPermission={(v, page, d) => checkComponentPermission(v, page, d)}
                                    calculateLineTotal={(el, form) => calculateLineTotal(el, form)}
                                />
                            </>
                        }
                    </>
                }
            />
            < Modal
                title={'Warning message'}
                open={modalVisible}
                onOk={() => setModalVisible(false)}
                onCancel={() => setModalVisible(false)}
                footer={
                    [
                        <Space direction="horizontal" align="center">
                            <NavLink
                                to={`#`} onClick={() => handleWarningYes()}
                                className={clsx(classes.AddMoreBtn, classes.bold, classes.textAlignLeft)}
                            >Yes</NavLink>
                            <NavLink
                                to={`#`} onClick={() => setModalVisible(false)}
                                className={clsx(classes.modalBtn, classes.bold, classes.textAlignLeft)}
                            >No</NavLink>
                        </Space>
                    ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)} >
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>Please note, changing the Tax Invoice to "No" should comply to GST law. Are you sure you want to continue to make this change ?</Typography>
            </Modal>
            {
                open &&
                <InvoiceModal open={open}
                    title={downloadTitle(previewData, 'sales-bill')}
                    handleClose={(o) => handleModalClose(o)}
                    link={preview ? '' : `/sales/sales-management/sales-order/${orderId}/view`}
                    {...props}
                    type={"create"}
                    proformaPreview={preview}
                    format={previewData?.invoice_billFormat || 'format1'}
                    priceIncludesTax={previewData?.business?.priceIncludesTax}
                    details={previewData} />
            }
        </Fragment >
    )
})